export const GTM_IDS = {
  nlPlatform: 'GTM-KVW9Z3',
  bePlatform: 'GTM-4JH8T7L',
  nlHeatPump: 'GTM-KLL290P',
  nlAirco: 'GTM-ADJ81LK',
  esPlatform: 'GTM-P02MMKQ',
  grPlatform: 'GTM-PVH4FK6P',
  nlHs: 'GTM-G33L9QK',
  dePlatform: 'GTM-DEPLT123',
};
